import { Palette } from '@/themes/themeOverrides/Palette';
import FilterIcon from '@/assets/icons/filter-icon.svg';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const filterStyles = {
    '&.filter-field': {
        position: 'relative',
        marginBottom: '10px',
        alignItems: 'center !important',
        '& .hide-filter': {
            position: 'absolute',
            right: '22px',
            top: '14px',
            transform: 'rotate(0deg)',
            transition: '0.3s ease',
            '&:hover': {
                transform: 'rotate(180deg)',
            },
        },
        '&.search-bar--hidden': {
            display: 'none !important',
        },
        '& .MuiFormHelperText-root': {
            display: 'none',
        },
        '& .MuiChip-root': {
            backgroundColor: Palette.gray.gray200,
            color: Palette.black,
            lineHeight: '16px',
            padding: '4px 8px',
            borderRadius: '8px',
            margin: '0 2px 0 0 !important',
            '& .MuiChip-deleteIcon': {
                marginRight: '0px',
                marginLeft: '0px',
                color: Palette.black,
            },
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root': {
            minWidth: '126px',
            background: 'transparent',
            '& .MuiInputBase-input': {
                lineHeight: '24px',
            },
            '&.MuiAutocomplete-inputRoot .MuiInputBase-input:focus': {
                width: '60px',
                marginRight: '20px',
            },
        },
        '& .RaFilterFormInput-spacer': {
            width: '20px',
        },
        '& .MuiFormControl-root .MuiInputLabel-root': {
            lineHeight: '24px',
            backgroundColor: Palette.gray.gray75,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 'calc(100% - 80px)',
            top: '-2px',
            color: Palette.black,
            transition: 'none !important',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                fontSize: '16px',
            },
            '&.MuiInputLabel-shrink': {
                top: '-14px',
                textOverflow: 'unset',
                transform: 'none',
                maxWidth: 'max-content',
                left: '10px',
            },
        },
        '& .MuiFormGroup-root .MuiFormControlLabel-root .MuiFormControlLabel-label': {
            whiteSpace: 'nowrap',
        },
        '& div[class*=" ra-input-search"]': {
            paddingRight: '0 !important',
            '& .MuiOutlinedInput-root': {
                paddingLeft: '50px !important',
            },
            '& .MuiInputAdornment-hiddenLabel': {
                position: 'absolute',
                left: '5px',
                top: '14px',
                height: '24px',
                width: '24px',
                '& .MuiIconButton-root': {
                    backgroundColor: 'transparent',
                },
            },
        },
        '& div[class*=" ra-input-search"] + .hide-filter': {
            margin: '0px 10px 0 10px',
            position: 'relative',
            left: 'auto',
            right: 'auto',
            top: '-12px',
        },
        '& .MuiAutocomplete-hasClearIcon .MuiInputBase-root .MuiAutocomplete-clearIndicator': {
            display: 'none',
        },
        '& .MuiInputBase-root .MuiInputAdornment-root .MuiSvgIcon-root': {
            color: Palette.black,
            fill: Palette.black,
        },
        '& .MuiSwitch-root': {
            marginBottom: '4px',
            marginLeft: '8px',
            '& + .MuiTypography-root': {
                fontSize: '14px',
            },
        },
        '& > .MuiChip-filled': {
            margin: '9px 50px 16px 0 !important',
            '& + .hide-filter': {
                right: '16px',
                top: '10px',
            },
        },
        '& [type="date"]': {
            lineHeight: '22px !important',
        },
        '& .MuiSwitch-sizeSmall': {
            height: '46px',
        },
        '& .ra-input-isActive .MuiSwitch-sizeSmall + .MuiTypography-root': {
            margin: '-7px 42px 0px 0px',
        },
        '& .ra-input-isActive .MuiSwitch-sizeMedium + .MuiTypography-root': {
            margin: '-2px 42px 0px 0px',
        },
    },
    '&.RaFilterForm-filterFormInput': {
        '& .MuiFormControl-root': {
            paddingRight: '40px',
            border: `2px solid ${Palette.gray.gray200}`,
            borderRadius: '12px',
            marginTop: '4px',
            '& .MuiInputBase-root fieldset': {
                border: 'none !important',
            },
        },
    },
    '&.filter-icon': {
        '& .MuiButton-startIcon': {
            backgroundImage: `url("${FilterIcon}")`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            '& svg.MuiSvgIcon-root': {
                visibility: 'hidden',
            },
        },
    },
    '&.MuiMenu-list': {
        '& .MuiMenuItem-root': {
            '& .MuiListItemIcon-root': {
                display: 'none',
            },
            '& .MuiListItemText-root': {
                '& .MuiTypography-root': {
                    fontSize: '14px',
                },
            },
        },
    },
};
